import { Articles } from "../../articles/entities";
import getWidgetByName from "../requests";

export const getArticlesByArticleType = async (articleType) =>
  getWidgetByName("articlelistingbyarticletypewidget", articleType)
    .then(Articles);
